import { Map } from "immutable"

import {
    getList,
    getItem,
    putItem,
    postItem,
    deleteItem
} from "./utils/entity-network-requests"

const entityName = "source"

export const getSourceList = (token, parameters) => {
    if (typeof parameters === "string" || parameters instanceof String) {
        // Actually a search term that comes from autocomplete
        parameters = new Map({ name: parameters })
    }
    return getList(entityName, parameters, token)
}
export const getSourceItem = (token, id) => getItem(entityName, id, token)
export const putSourceItem = (token, id, source) =>
    putItem(entityName, id, source, token)
export const postSourceItem = (token, source) =>
    postItem(entityName, source, token)
export const deleteSourceItem = (token, id) => deleteItem(entityName, id, token)
// dashboard-api checks a Rendered listing source's settings by the knowledge-scraper's rules, without saving them
export const checkRenderedListing = (token, settings) =>
    postItem(`${entityName}/rendered_listing_check`, settings, token)
// dashboard-api renders a page with Firecrawl and groups its links by shape, to set up a Rendered listing source
export const discoverRenderedListing = (token, url) =>
    postItem(`${entityName}/rendered_listing_discover`, { url }, token)
